import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { includes } from "lodash";
import { OrderType } from "src/app/types/orders/order";

const useOrderTypeOptions = (optionsToUse?: OrderType[]) => {
    const [orderTypeOptions, setOrderTypeOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);
    const { formatMessage } = useIntl();

    useEffect(() => {
        setLoading(true);
        const orderTypeListBuilder: Array<SimpleFormSelectOption> = [];
        for (const key in OrderType) {
            if (!optionsToUse || includes(optionsToUse, key))
                orderTypeListBuilder.push({
                    value: OrderType[key as keyof typeof OrderType],
                    label: formatMessage({
                        id: `common.field.orderType.${OrderType[key as keyof typeof OrderType]}`,
                    }),
                });
        }
        setOrderTypeOptions(orderTypeListBuilder);
        setLoading(false);
    }, []);

    return { orderTypeOptions, loading };
};

export default useOrderTypeOptions;
